import React from "react";
import useUserInfo from "../../../Hooks/useUserInfo";
import { useAudio } from "../../../Providers/AudioProvider";
import { logPageView } from "../../../components/analytics";
import task from "../Task";
import "./carrace.css";
import GameBoard from "./comp/GameBoard";

const CarRace = () => {
  const { userDetails, updateUserInfo } = useUserInfo();
  const playClick = useAudio();

  React.useEffect(() => {
    logPageView("CarRacePage", "Car Race Game");
  }, []);

  const toogleMenu = () => {
    playClick();
    updateUserInfo((prev) => ({
      ...prev,
      isPlay: false,
      currentComponent: task,
      currentComponentText: "task",
      lastComponent: userDetails?.userDetails.currentComponent,
      lastComponentText: userDetails?.userDetails.currentComponentText,
      isMenu: true,
      menuCount: userDetails?.userDetails?.menuCount + 1,
    }));
  };

  return (
    <div className="game-carrace">
      <img
        onClick={toogleMenu}
        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg"
        className="cancel-fullcar"
        alt="Close"
      />
      <div className="game-containercar">
        <GameBoard />
      </div>
    </div>
  );
};

export default CarRace;
